<template>
  <TemplateView>
    <v-container>
      <PlanningTableWorkFilter v-model="filter" @input="loadData"/>
      <template v-if="data.length">
        <PlanningTableWorkShow :format-date="formatDate()" :total="total">
          <BaseTableView :head="$vuetify.breakpoint.xlOnly ? headerTableLarge : headerTableSmall">
            <template v-for="(item, i) in data">
              <template v-if="$vuetify.breakpoint.xlOnly">
                <template v-if="item.work_types.length">
                  <tr
                    v-for="(work, j) of item.work_types"
                    :key="i + '_' + j"
                    class="table_large"
                    :class="Number(j) === 0
                    ? 'br-top br-x'
                    : Number(i) + 1 === Object.keys(data).length
                      ? 'br-x br-bottom'
                      : 'br-x'"
                  >
                    <td v-if="Number(j) === 0" :rowspan="Number(j) === 0 ? item.work_types.length : 1">
                      <div class="d-flex align-center">
                        <div class="mr-2">{{ i + 1 }}</div>
                        <div>
                          <IconPlanning :name="item.status" width="24" height="24" class="mr-2"/>
                        </div>
                        <div>{{ item.name }}</div>
                      </div>
                    </td>
                    <td v-if="Number(j) === 0" :rowspan="Number(j) === 0 ? item.work_types.length : 1">
                      {{ item.city }}
                    </td>
                    <td v-if="Number(j) === 0" :rowspan="Number(j) === 0 ? item.work_types.length : 1">
                      {{ item.work_client ? item.work_client.name : '—' }}
                    </td>
                    <td :class="Number(j) + 1 === item.work_types.length ? '' : 'br-bottom-none'"
                        class="pa-2 br-x-none">{{ work.work_type.name }}
                    </td>
                    <td :class="Number(j) + 1 === item.work_types.length ? '' : 'br-bottom-none'">
                      {{ work.work_type.measure }}
                    </td>
                    <td :class="Number(j) + 1 === item.work_types.length ? '' : 'br-bottom-none'"
                        v-if="(work.size - work.done) <= 0"
                    >0,00
                    </td>
                    <td :class="Number(j) + 1 === item.work_types.length ? '' : 'br-bottom-none'"
                        v-else
                    >{{ $formatCurrency(work.size - work.done) }}
                    </td>
                    <td :class="Number(j) + 1 === item.work_types.length ? '' : 'br-bottom-none'">
                      {{ $formatCurrency(work.price) }}
                    </td>
                    <td :class="Number(j) + 1 === item.work_types.length ? '' : 'br-bottom-none'"
                        class="pa-2 br-x-none">{{ $formatCurrency(work.total) }}
                    </td>
                    <td v-if="Number(j) === 0" :rowspan="Number(j) === 0 ? item.work_types.length : 1">
                      {{ $formatCurrency(item.total) }}
                    </td>
                  </tr>
                </template>
                <tr v-else :key="i + '_'">
                  <td>
                    <div class="d-flex align-center">
                      <div class="mr-2">{{ i + 1 }}</div>
                      <div>
                        <IconPlanning :name="item.status" width="24" height="24" class="mr-2"/>
                      </div>
                      <div>{{ item?.name || '—' }}</div>
                    </div>
                  </td>
                  <td>{{ item?.city || '—' }}</td>
                  <td>{{ item.work_client ? item.work_client.name : '—' }}</td>
                  <td v-for="l in 5" :key="'numb_' + l"> {{ '—' }}</td>
                  <td>{{ $formatCurrency(item.total) }}</td>
                </tr>
              </template>
              <template v-else>
                <tr :key="i + '_'" class="table_small">
                  <td>
                    <div class="d-flex align-center">
                      <div class="mr-2">{{ i + 1 }}</div>
                      <div>
                        <IconPlanning :name="item.status" width="24" height="24" class="mr-2"/>
                      </div>
                      <div>{{ item?.name || '—' }}</div>
                    </div>
                  </td>
                  <td>{{ item?.city || '—' }}</td>
                  <td>{{ item.work_client ? item.work_client.name : '—' }}</td>
                  <td>{{ $formatCurrency(item.total) }}</td>
                  <td v-if="item.work_types.length" class="table_inner px-md-15">
                    <BaseTableView list-view="mdAndUp" :head="headerTableInner">
                      <PlanningTableWorkShowItemInner
                        v-for="(work, j) of item.work_types"
                        :key="i + '_' + j"
                        :data="work"
                      />
                    </BaseTableView>
                  </td>
                </tr>
              </template>
            </template>
          </BaseTableView>
        </PlanningTableWorkShow>
        <PlanningTableWorkPDF :format-date="formatDate()" :total="$formatCurrency(total)" :data="data"/>
      </template>
      <Plug v-else/>
    </v-container>
  </TemplateView>
</template>

<script>
import TemplateView from 'components/templates/TemplateView'
import PlanningTableWorkFilter from "components/planning/table/PlanningTableWorkFilter";
import {mapActions, mapGetters} from "vuex";
import PlanningTableWorkShow from "components/planning/table/PlanningTableWorkShow";
import BaseTableView from "components/base/tableview/BaseTableView";
import IconPlanning from "components/icons/planning/IconPlanning";
import PlanningTableWorkShowItemInner from "components/planning/table/PlanningTableWorkShowItemInner";
import Plug from "components/Plug";
import PlanningTableWorkPDF from "components/planning/table/PlanningTableWorkPDF";

export default {
  name: 'planningTableWork',
  components: {
    PlanningTableWorkPDF,
    Plug,
    PlanningTableWorkShowItemInner,
    IconPlanning,
    BaseTableView,
    PlanningTableWorkShow,
    PlanningTableWorkFilter,
    TemplateView
  },
  computed: {
    ...mapGetters(['loadingAnimation']),
    ...mapGetters('workClientProject', ['workClientProjectOrdersReport']),
    t() {
      return this.localStorage.translations.pages['planning_orders'].table
    },
    data() {
      let result = this.workClientProjectOrdersReport
      result.forEach(cur => {
        cur['work_types'].forEach(w => {
          if (Number(w.size - w.done) <= 0) {
            w.total = 0;//w.done * w.price
          } else {
            w.total = (w.size - w.done)  * w.price
          }
        })
        cur.total = cur['work_types'].reduce((sum, w) => {
          return sum + w.total
        }, 0)
      })
      return result
    },
    total() {
      return this.data.reduce((sum, cur) => {
        return sum + cur.total
      }, 0)
    },
    headerTableInner() {
      return [
        {text: this.t['nazvanie-raboty']},
        {text: this.t['measure']},
        {text: this.t['obem-rabot']},
        {text: this.t['tsena']},
        {text: this.t['v-itoge']},
      ]
    },

    headerTableLarge() {
      return [
        {text: '№ ' + this.t['proekt']},
        {text: this.t['gorod']},
        {text: this.t['klient']},
        {text: this.t['nazvanie-raboty']},
        {text: this.t['measure']},
        {text: this.t['obem-rabot']},
        {text: this.t['tsena']},
        {text: this.t['v-itoge']},
        {text: this.t['obshchiy']},
      ]
    },

    headerTableSmall() {
      return [
        {text: '№ ' + this.t['proekt']},
        {text: this.t['gorod']},
        {text: this.t['klient']},
        {text: this.t['obshchiy']},
      ]
    },
  },
  data: () => ({
    filter: ['in_progress'],
  }),
  created() {
    this.loadData()
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectOrdersReport']),
    loadData() {
      this.onWorkClientProjectOrdersReport({filtersStatus: this.filter.length ? this.filter : null})
    },

    formatDate() {
      let date = new Date()
      let formattedDate =
        (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
        '.' +
        (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '.' +
        date.getFullYear()
      return formattedDate
    },
  }
}
</script>

<style scoped lang="scss">
tbody {
  tr {
    &:hover {
      background: #f2f2f2 !important;
    }

    &.table_large {
      border: none;

      &:last-child {
        border-bottom: 1px solid #d1d1d1;
      }

      &.br, .br {
        &-top {
          border-top: 1px solid #d1d1d1;
        }

        &-x {
          border-left: 1px solid #d1d1d1;
          border-right: 1px solid #d1d1d1;

          &-none {
            border-left: none;
            border-right: none;
          }
        }

        &-bottom {
          border-bottom: 1px solid #d1d1d1;

          &-none {
            border-bottom: none;
          }
        }
      }

      td {
        height: auto;
      }
    }

    .table_inner {
      grid-column-start: 1;
      grid-column-end: 5;
      border-bottom: none;
      padding-bottom: 0;

      &:before {
        display: none !important;
      }

      :deep() .table {
        &_list_view {
          tr {
            border-bottom: none;
            border-left: none;
            border-right: none;
            border-top: 1px solid #dedede;
            background-color: transparent;

            td, th {
              height: auto !important;
            }

            th {
              font-size: 0.75rem !important;
              font-weight: bold;
              color: #adadad !important;
            }

            td:nth-child(2) {
              width: 100px !important;
            }

            td:nth-child(3) {
              width: 150px !important;
            }

            td:nth-child(4) {
              width: 150px !important;
            }

            td:nth-child(5) {
              width: 150px !important;
            }
          }
        }

        &_card_view {
          tr {
            background-color: #fafafa;
            border-left: 1px solid #f2f2f2;
            border-right: 1px solid #f2f2f2;

            td {
              border-color: #f2f2f2;
            }
          }
        }
      }

    }
  }
}

.table_small {
  background-color: white;
  border: none;
  padding: 20px;

  &:first-child {
    border-top: none;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  &:last-child {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }

  &:hover {
    background-color: #ffffff !important;
  }

  td:nth-child(4) {
    border-bottom: none !important;
  }
}
</style>
